import { StartupService } from './../../../shared/services/startup.service';
import { EnrollmentProgramsService } from './../../../shared/services/enrollment-programs.service';
import { EnrollmentProgramModel } from './../../../shared/models/enrollment-program.model';
import { Router } from '@angular/router';
import { SelectListItemModel } from './../../../shared/models/select-list-item.model';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'online-app-login-types',
  templateUrl: './login-types.component.html',
  styleUrls: ['./login-types.component.scss']
})
export class LoginTypesComponent implements OnInit {

  programs:EnrollmentProgramModel[];

  constructor(
    private router:Router,
    private _programService:EnrollmentProgramsService,
    private sturtupSer:StartupService
  ) {
      this._programService.getEnrolleePrograms().subscribe(data=>{
        this.programs=data;
      })
   }

  ngOnInit() {
    this.sturtupSer.setCurrentTheme();
  }

  protected programChanged(e){
    this._programService.getEnrolleProgramByAlias(e.value).subscribe(i=>{
      this.sturtupSer.setCurrentTheme(i.orgName);
    })
    this.router.navigate([`/security/${e.value}/login`])
  }

}



// WEBPACK FOOTER //
// ./src/app/security/security/login-types/login-types.component.ts